
import "./legacyShell.css"
/*
import {
    getLocalDateTime,
    getRandomNumber,
    getUserData,
    getAppMode,
} from 'app/shared/utils/comUtil'

*/
//window.__QURAM_WOCR_DEFER_INIT__ = false;

const LEGACY_BASE = "/quramOCR/";
const STYLESHEETS = [`${LEGACY_BASE}css/main.css`, `${LEGACY_BASE}css/anim.css`, `${LEGACY_BASE}css/bootstrap.css`, `${LEGACY_BASE}css/style.css`]
const SCRIPTS = [
  `${LEGACY_BASE}js/jquery/jquery-1.10.2.min.js`,
  `${LEGACY_BASE}js/webrtc/adapter/adapter-latest.js`,
  `${LEGACY_BASE}js/utils/support.js`,
  `${LEGACY_BASE}js/wocr.js`,
];

/*
export const getCommonHeader = () => {
    const appMode = getAppMode()
    const csrfToken = getUserData('tkn', false)
    const screId = window.location.pathname.slice(1) // 화면번호
    const rqstYmd = getLocalDateTime('YYYYMMDD')
    const rqstHms = getLocalDateTime('hhmmssn')
    const trnRqstTs = rqstYmd + rqstHms
    let sysEnvrDcd = 'D'

    if (appMode === 'production') sysEnvrDcd = 'P'
    else if (appMode === 'test') sysEnvrDcd = 'T'

    // 글로벌ID 채번 규칙 : 전송일자(8) + 망구분(1) + 시스템코드(3) + 업무구분코드(3) + 일련번호(1) + 전송일시(9) + 랜덤시퀀스(5) + 진행구분번호(4) = 34 byte
    const guid =
        rqstYmd +
        sysEnvrDcd +
        'UIB' +
        'MAO' +
        '1' +
        rqstHms +
        getRandomNumber(5) +
        '0000'

    const reqHeader = {
        guid: guid, // GUID
        traceId: '', // 트레이스ID
        rqstSysDcd: 'UIB', // 요청시스템구분코드
        rqstSysBswrDcd: 'MAO', // 요청시스템업무구분코드
        clntIp: '', // 클라이언트IP     - 공백 고정
        clntMac: '', // 클라이언트MAC   - 공백 고정
        userIdntNo: '', // 사용자ID     - 공백 고정
        sysEnvrDcd: sysEnvrDcd, // 시스템환경구분코드
        trnRqstTs: trnRqstTs, // 거래요청일시
        trnMctm: '', // 거래유지시간
        screId: screId.split('/').includes('gw')
            ? 'gw'
            : screId.split('/').pop(), // 화면번호
        lnggDcd: 'ko', // 언어구분코드
        tkn: csrfToken, // 토큰
    }

    return reqHeader
}
*/


function loadStylesheet(href: string): Promise<void> {
	return new Promise((resolve, reject) => {
	
	const existing = document.querySelector(`link[rel="stylesheet"][href="${href}"]`);

	if(existing){
		resolve();
		return;
	}
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Failed to load ${href}`));
    document.head.appendChild(link);

  });
}

function loadScript(src: string): Promise<void> {
	return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = src;
    s.async = false;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(s);
  });
  
}

let loadPromise: Promise<void> | null = null;

export function loadLegacyWocr(): Promise<void> {
  if (loadPromise) return loadPromise;
  loadPromise = (async () => {

	
	for (const src of SCRIPTS) {
		
	  await loadScript(src);
	}
	
	for (const href of STYLESHEETS) {
	  await loadStylesheet(href);
	}

	/*	
	let commonHeader = getCommonHeader();
	let headerString = JSON.stringify(commonHeader);
	*/
   //const init = (window as any).__runMobaiOcrInit;
   // if (typeof init === "function") { 
   //   init();
   // } else {
   //   console.error("wocr: __runMobaiOcrInit is missing after script load");
   // }
  })();
  
  
  return loadPromise;
}
/*

let loadPromise: Promise<void> | null = null;

export function loadLegacyWocr(): Promise<void> {
	
	if (loadPromise) return loadPromise;


  	return loadPromise;
}
*/